var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-nav"},[_c('span',{class:`swiper-arrow swiper-prev ${_vm.type === 'simple' ? 'simple' : ''}`},[_c('i',{staticClass:"icon-chevron-left"})]),_vm._v(" "),_c('div',{class:`swiper-arrow swiper-next ${_vm.type === 'simple' ? 'simple' : ''}`},[_c('i',{staticClass:"icon-chevron-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }